import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { LambdaResponsePayload } from "@pages/Article/types/Alacrity";
import { ENVIRONMENT } from "@util/constant";
import { getEnvironmentDomain } from "@util/helpers";

import useAlacrity from "./useAlacrity";

export default function useGenerateGiftURL(
  isPremium: boolean,
  isSubscriber: boolean,
  setAlacrityRes: React.Dispatch<
    React.SetStateAction<LambdaResponsePayload | undefined>
  >,
  aovisitorID?: string
) {
  const { pathname } = useLocation();
  const { generateGiftURL } = useAlacrity();

  useEffect(() => {
    if (!isPremium) return;
    if (!isSubscriber) return;

    const fetchCall = async () => {
      try {
        if (!aovisitorID) throw new Error("aovisitorID is not present");

        const response = await generateGiftURL(
          `${getEnvironmentDomain(ENVIRONMENT)}${pathname}`,
          aovisitorID
        );

        setAlacrityRes(response);
      } catch {
        console.log("aovisitorID is not present"); // eslint-disable-line no-console
      }
    };

    fetchCall();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
}
